import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { useNavigate } from "react-router-dom";

import {
  NavigationButton,
  BottomActions,
  SecondaryButton
} from "~/components/kiosk/bottom-actions/bottom-actions";
import { MenuQuickCheckoutButtons } from "~/components/kiosk/payment-buttons/menu-quick-checkout-buttons";
import { SlideUpTransition } from "~/components/kiosk/ui/animation/slide-up-transition";
import { kioskActions } from "~/stores/kiosk-session/actions";
import { priceFormatter } from "~/utils/price-formatter";
import { useKioskStore } from "~/routes/__app.kiosk/route";
import { useKioskProducts } from "~/stores/kiosk-session/hooks/use-kiosk-products";
import { useKioskSessionLocale } from "~/stores/kiosk-session/hooks/use-kiosk-session";
import { T, useT } from "@repo/transifex";

export const Footer = () => {
  const { productsBasket, currency, unitTotalPayableInclVat, quantitySum } =
    useKioskProducts();
  const locale = useKioskSessionLocale();
  const hidePrices = useKioskStore(
    (state) => state.till.moduleConfig.hidePrices
  );
  const navigate = useNavigate();
  const t = useT();

  return (
    <SlideUpTransition show={productsBasket.length > 0}>
      <BottomActions
        secondaryButton={
          <SecondaryButton
            className="h-full flex-col gap-y-5"
            icon={faXmark}
            onClick={() => {
              kioskActions.session.reset();
            }}
          >
            <T _str="Cancel" />
          </SecondaryButton>
        }
        primaryButton={
          <NavigationButton
            ariaLabel={t("View basket")}
            totalAmount={
              hidePrices
                ? undefined
                : priceFormatter({
                    value: unitTotalPayableInclVat,
                    currency,
                    locale
                  })
            }
            numberOfProducts={t("{quantitySum} items", {
              quantitySum
            })}
            onClick={() => {
              navigate("/kiosk/basket");
            }}
          />
        }
      >
        <MenuQuickCheckoutButtons />
      </BottomActions>
    </SlideUpTransition>
  );
};
